/*
 * File: /src/router/routes/exports.js
 * Created Date: Sunday June 27th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 27th June 2021 11:17:08 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
const Exports = () =>
  import(
    /* webpackChunkName: "Exports" */ 'src/components/Dashboard/Views/Exports/Export.vue'
  );

export const exportRoutes = [
  {
    path: 'exports/',
    name: 'Contact Exports',
    component: Exports
  }
];
